module.exports = __webpack_public_path__ + "static/media/google-login-logo.4bbd03f2.png";